<script lang="ts">
  import { MasonryGrid } from '@egjs/svelte-grid';

  import type { ItemWithOriginalSize } from '@shared/types';

  //eslint-disable-next-line
  type ProductListItem = $$Generic<ItemWithOriginalSize & { id: string | number }>;
  export let products: ProductListItem[];

  const breakpoints = {
    default: '360px',
    'min-1280': `calc(25vw - 6rem)`,
    'min-1024': `calc(33vw - 4rem)`,
    'min-768': `calc(33vw - 4rem)`,
  };

  $: gridAlign = products.length > 3 ? 'justify' : 'start';
</script>

<MasonryGrid
  class="masonry-container transition-[height] duration-300 md:-mx-6"
  defaultDirection="{'end'}"
  align="{gridAlign}"
  column="{0}"
  columnSizeRatio="{0}"
  gap="{0}"
>
  <!-- TODO - create MasonryGrid with UL container -->
  <!-- <ul class="flex w-full flex-wrap"> -->
  {#each products as product}
    {#key product.id}
      <div class="item w-full pb-6 md:w-4/12 md:px-6 lg:pb-12 xl:w-3/12">
        <slot {product} {breakpoints} />
      </div>
    {/key}
  {/each}
  <!-- </ul> -->
</MasonryGrid>
